import { IDriverMetricsDTO, IDriverMetricsFilters, IDriverMetricsResponse } from 'src/types'

const storageKeyPrefix = 'operatorMetrics'

export function getStorageKey(filters: IDriverMetricsFilters): string {
  const { startDate, endDate, organizationId } = filters
  const start = new Date(startDate).toISOString().split('T')[0]
  const end = new Date(endDate).toISOString().split('T')[0]
  return `${storageKeyPrefix}_${organizationId}_${start}_${end}`
}

export function saveMetricsToLocalStorage(key: string, data: IDriverMetricsDTO[]): void {
  if (!localStorage.getItem(key)) {
    const item = {
      value: data,
      expiry: new Date().getTime() + 3600000
    }
    localStorage.setItem(key, JSON.stringify(item))
  }
}

export function getMetricsFromLocalStorage(key: string): IDriverMetricsDTO[] | null {
  const storedMetrics = localStorage.getItem(key)

  if (storedMetrics) {
    const item = JSON.parse(storedMetrics)
    const now = new Date()

    if (now.getTime() > item.expiry) {
      localStorage.removeItem(key) // Remove expired item
      return null
    }
  }

  return storedMetrics ? JSON.parse(storedMetrics).value : null
}



// WEBPACK FOOTER //
// ./src/state/actions/drivers/local-storage.ts